/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Group_Customer_DescriptionInputs */

const en_users_form_group_customer_description = /** @type {(inputs: Users_Form_Group_Customer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer accounts associated with one or multiple client organizations.`)
};

const pt_br2_users_form_group_customer_description = /** @type {(inputs: Users_Form_Group_Customer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contas de clientes associadas a uma ou mais organizações.`)
};

/**
* | output |
* | --- |
* | "Customer accounts associated with one or multiple client organizations." |
*
* @param {Users_Form_Group_Customer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_group_customer_description = /** @type {((inputs?: Users_Form_Group_Customer_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Group_Customer_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_group_customer_description(inputs)
	return pt_br2_users_form_group_customer_description(inputs)
});